import Face from "@/public/icon/face.svg";
import Insta from "@/public/icon/insta.svg";
import Tiktok from "@/public/icon/tiktok.svg";
import Youtube from "@/public/icon/youtube.svg";
import Link from "next/link";

const Socials = ({setting}) => {
  return (
    <div className="socials">
      <Link href={setting.facebook} target="_blank">
        <Face />
      </Link>
      <Link href={setting.instagram} target="_blank">
        <Insta />
      </Link>
      <Link href={setting.tiktok} target="_blank">
        <Tiktok />
      </Link>
      <Link href={setting.youtube} target="_blank">
        <Youtube />
      </Link>
    </div>
  );
};

export default Socials;
